import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 10,
};

export const userListTableControllerSlice = createSlice({
    name: 'userListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = userListTableControllerSlice.actions;

export default userListTableControllerSlice.reducer;